module.exports = __webpack_public_path__ + "static/media/bot-icon-640.de644cc4.png";